(() => {
  const subNavEls = document.querySelectorAll('[data-sub-navigation]');

  if (!subNavEls.length) {
    return;
  }

  const DESKTOP_BREAKPOINT = 741;

  const getHeaderOffset = () => {
    const headerValue = getComputedStyle(document.documentElement)
      .getPropertyValue('--athena-header-total-height')
      .trim();
    const parsedValue = Number.parseFloat(headerValue);

    return Number.isFinite(parsedValue) ? parsedValue : 0;
  };

  const getDesktopEdgePadding = () => Math.max(20, window.innerWidth * 0.024);

  const getDesktopNavWidth = () => {
    const minWidth = 240;
    const maxWidth = 520;
    const preferredWidth = window.innerWidth * 0.3;

    return Math.min(Math.max(preferredWidth, minWidth), maxWidth);
  };

  const getTargetIdFromLink = (linkEl) => {
    if (linkEl.dataset.subNavigationTarget) {
      return linkEl.dataset.subNavigationTarget;
    }

    const href = linkEl.getAttribute('href') || '';
    const hashIndex = href.indexOf('#');

    if (hashIndex === -1) {
      return '';
    }

    const hashValue = href.slice(hashIndex + 1);

    return decodeURIComponent(hashValue).trim();
  };

  subNavEls.forEach((subNavEl) => {
    const linkEls = Array.from(subNavEl.querySelectorAll('[data-sub-navigation-link]'));

    if (!linkEls.length) {
      return;
    }

    const firstFaqSectionEl = document.querySelector('#main > .shopify-section--faq-list');
    const contentBoundaryEls = Array.from(
      document.querySelectorAll('#main > .shopify-section--faq-list, #main > .shopify-section--get-in-touch')
    );
    const footerBoundaryEl =
      document.querySelector('.shopify-section--footer') ||
      document.querySelector('footer') ||
      contentBoundaryEls[contentBoundaryEls.length - 1];

    const resetDesktopStickyStyles = () => {
      subNavEl.style.position = '';
      subNavEl.style.top = '';
      subNavEl.style.left = '';
      subNavEl.style.width = '';
      subNavEl.style.maxHeight = '';
    };

    const updateDesktopStickyPosition = () => {
      if (window.innerWidth < DESKTOP_BREAKPOINT || !firstFaqSectionEl || !footerBoundaryEl) {
        resetDesktopStickyStyles();
        return;
      }

      const navHeight = subNavEl.offsetHeight;
      if (!navHeight) {
        return;
      }

      const edgePadding = getDesktopEdgePadding();
      const stickyTop = getHeaderOffset() + edgePadding;
      const startTop = firstFaqSectionEl.getBoundingClientRect().top + window.scrollY + edgePadding;
      const footerTop = footerBoundaryEl.getBoundingClientRect().top + window.scrollY;
      const maxTop = Math.max(startTop, footerTop - navHeight - edgePadding);
      const stickyTopDoc = window.scrollY + stickyTop;
      const targetTopDoc = Math.min(Math.max(stickyTopDoc, startTop), maxTop);
      const availableHeight = Math.max(footerTop - targetTopDoc - edgePadding, navHeight);

      subNavEl.style.position = 'fixed';
      subNavEl.style.top = `${targetTopDoc - window.scrollY}px`;
      subNavEl.style.left = `${edgePadding}px`;
      subNavEl.style.width = `${getDesktopNavWidth()}px`;
      subNavEl.style.maxHeight = `${availableHeight}px`;
    };

    const targetsById = new Map();

    linkEls.forEach((linkEl) => {
      const targetId = getTargetIdFromLink(linkEl);
      if (!targetId) {
        return;
      }

      const targetEl = document.getElementById(targetId);
      if (targetEl) {
        targetsById.set(targetId, targetEl);
      }
    });

    const targetIds = Array.from(targetsById.keys());
    if (!targetIds.length) {
      return;
    }

    const setActiveLink = (targetId, shouldCenterLink) => {
      linkEls.forEach((linkEl) => {
        const linkTargetId = getTargetIdFromLink(linkEl);
        const isActive = linkTargetId === targetId;

        linkEl.classList.toggle('active', isActive);
        linkEl.setAttribute('aria-current', isActive ? 'true' : 'false');

        if (isActive && shouldCenterLink && window.innerWidth <= 740) {
          linkEl.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
          });
        }
      });
    };

    const getScrollOffset = () => {
      const headerOffset = getHeaderOffset();

      if (window.innerWidth >= DESKTOP_BREAKPOINT) {
        return headerOffset + getDesktopEdgePadding() + 24;
      }

      return headerOffset + subNavEl.offsetHeight + 24;
    };

    const scrollToTarget = (targetId, updateHash) => {
      const targetEl = targetsById.get(targetId);

      if (!targetEl) {
        return;
      }

      const targetTop = targetEl.getBoundingClientRect().top + window.scrollY;
      const scrollTop = Math.max(targetTop - getScrollOffset(), 0);

      window.scrollTo({
        top: scrollTop,
        behavior: 'smooth'
      });

      setActiveLink(targetId, true);

      if (updateHash) {
        history.replaceState(null, '', `#${targetId}`);
      }
    };

    linkEls.forEach((linkEl) => {
      linkEl.addEventListener('click', (event) => {
        const targetId = getTargetIdFromLink(linkEl);

        if (!targetId || !targetsById.has(targetId)) {
          return;
        }

        event.preventDefault();
        scrollToTarget(targetId, true);
      });
    });

    let activeTargetId = '';
    let isTicking = false;

    const updateActiveFromScroll = () => {
      const markerPosition = getScrollOffset();
      let nextActiveTargetId = targetIds[0];

      targetIds.forEach((targetId) => {
        const targetEl = targetsById.get(targetId);
        if (!targetEl) {
          return;
        }

        if (targetEl.getBoundingClientRect().top <= markerPosition) {
          nextActiveTargetId = targetId;
        }
      });

      if (nextActiveTargetId !== activeTargetId) {
        activeTargetId = nextActiveTargetId;
        setActiveLink(nextActiveTargetId, false);
      }
    };

    const updateStickyAndActive = () => {
      updateDesktopStickyPosition();
      updateActiveFromScroll();
      isTicking = false;
    };

    const onScroll = () => {
      if (isTicking) {
        return;
      }

      isTicking = true;
      window.requestAnimationFrame(updateStickyAndActive);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      updateDesktopStickyPosition();
      updateActiveFromScroll();
    });

    const hashTargetId = window.location.hash.replace('#', '').trim();

    updateDesktopStickyPosition();

    if (hashTargetId && targetsById.has(hashTargetId)) {
      window.requestAnimationFrame(() => {
        scrollToTarget(hashTargetId, false);
      });
    } else {
      updateActiveFromScroll();
    }
  });
})();
